import Notifications from 'vue-notification';
import Vue from 'vue';

Vue.use(Notifications);
